// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2Ioxv","col":"styles_col__1rUh7"};